// Body of the lookup-orders-by-email confirmation page: the legacy sealy
// account-page layout -- the brand heading, the static confirmation copy, and
// the decorative account image. The copy is the sealy legacy template's own
// (this site's copy differs from the shared LookupOrdersByEmailConfirmationBody
// defaults), reproduced verbatim -- including the legacy "Tempurpedic.com
// order" line, a pre-existing copy bug on sealy kept for behavior
// preservation; sealy serves en-us only, so the plain literals match the
// legacy {% blocktrans %} output.
import React from "react";

import { AccountSplitShell } from "../AccountSplitShell";

export const LookupOrdersByEmailConfirmationPageBody =
    (): React.JSX.Element => {
        return (
            <AccountSplitShell
                heading="Your Sealy® Orders"
                sectionHeading="Your Order Status"
            >
                <div>
                    <p>
                        Your order status request has been submitted. If an
                        order associated with this email address is located,
                        we&rsquo;ll send you a link to view your order history.
                        You should receive an email from us within a few
                        minutes.
                    </p>
                    <p>
                        If you don&rsquo;t receive an order status email from us
                        within 10 minutes, please check your spam folder. Also
                        please verify that the email address you entered is the
                        exact same email address you used to place your
                        Tempurpedic.com order.
                    </p>
                </div>
            </AccountSplitShell>
        );
    };
